<script setup lang="ts">
	const rConf = useRuntimeConfig()

	const { data: alerts } = await useFetch(rConf.public.apiBase+'/rest/websitealerts')
	const activeAlerts = computed(() => {
		let a = []
		if (alerts.value) {
			alerts.value.forEach((item: any) => {
				const now = new Date()
				const start = new Date(item.display_start)
				const end = new Date(item.display_end)
				//console.log(start, end, now, now >= start && now <= end)
				if(now >= start && now <= end)
					a.push(item)
			})
		}
		return a
	})
</script>

<template>
	<div v-if="activeAlerts?.length" class="w-full bg-red-500 text-white">
		<GsPageSection>
			<div v-for="(item,idx) in activeAlerts" :key="idx" class="*:text-white! py-4">
				<p class="font-bold">{{ item.title }}</p>
				<div v-html="item.description" class="[&_p]:text-white!" />
			</div>
		</GsPageSection>
	</div>
</template>

<style scoped>

</style>
